import defer from '../defer';

const domCompletePromise = defer();
const domInteractivePromise = defer();
const domLoadingPromise = defer();
const windowOnLoadPromise = defer();

function checkEntries(entries) {
  entries.forEach(entry => {
    if (entry.domComplete) {
      domCompletePromise.resolve(
        entry.domComplete - entry.domContentLoadedEventEnd,
      );
    }
    if (entry.domContentLoadedEventStart) {
      domInteractivePromise.resolve(
        entry.domContentLoadedEventStart - entry.domInteractive,
      );
    }
    if (entry.domInteractive) {
      domLoadingPromise.resolve(entry.domInteractive - entry.unloadEventEnd);
    }
    if (entry.loadEventEnd) {
      windowOnLoadPromise.resolve(entry.loadEventEnd - entry.loadEventStart);
    }
  });
}

if (typeof window !== 'undefined') {
  if ('performance' in window) {
    if ('PerformanceObserver' in window) {
      const perfObserver = new PerformanceObserver(list => {
        const entries = list.getEntries();
        checkEntries(entries);
      });
      perfObserver.observe({ entryTypes: ['navigation'] });
    } else if (window.onload) {
      window.onload(() => {
        const entries = performance.getEntriesByType('navigation');
        checkEntries(entries);
      });
    }
  }
}

const getDomComplete = () => domCompletePromise.promise;
const getDomInteractive = () => domInteractivePromise.promise;
const getDomLoading = () => domLoadingPromise.promise;
const getWindowLoad = () => windowOnLoadPromise.promise;

export { getDomComplete, getDomInteractive, getDomLoading, getWindowLoad };
